import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';

export default function Checkbox({ className, ...props }) {
  return (
    <input
      type="checkbox"
      className={classnames(styles.checkbox, className)}
      {...props}
    />
  );
}
